module.exports = __webpack_public_path__ + "static/media/video-retraining-ms.c036c3c6.vtt";